import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useStore, { IStore } from 'app/store';
import ListBuilder from '../../../modules/admin/listBuilder/ListBuilder';
import { IOptionProps } from 'app/modules/admin/manageRequests/models';

const ListBuilderPage: React.FC = () => {
    const setSearchOrigin = useStore((state: IStore) => state.setSearchOrigin);
    const [selectedKeys, setSelectedKeys] = useState<IOptionProps[]>([]);
    const history = useHistory();
    useEffect(() => {
        setSearchOrigin(history?.location?.pathname);
    }, []);
    return (
        <>
            <ListBuilder 
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
            />
        </>
    );
};

export default ListBuilderPage;